@import 'core';

/**
 * @prop --ads-expansion-panel-border-color: Toggle border color
 * @prop --ads-expansion-panel-content-background-color: Content background color
 * @prop --ads-expansion-panel-content-color: Content text color
 * @prop --ads-expansion-panel-content-padding: Content padding
 *
 * @prop --ads-expansion-panel-hr-color: Horizontal Rule Color
 *
 * @prop --ads-expansion-panel-toggle-background-color-hover: Hovered toggle background color
 * @prop --ads-expansion-panel-toggle-background-color: Toggle Background color
 * @prop --ads-expansion-panel-toggle-color-hover: Hovered toggle text color
 * @prop --ads-expansion-panel-toggle-color: Toggle text color
 * @prop --ads-expansion-panel-toggle-icon-color-hover: Hovered Toggle icon color
 * @prop --ads-expansion-panel-toggle-icon-color: Toggle icon color
 * @prop --ads-expansion-panel-toggle-padding: Toggle padding
 */

:host {
  display: block;
}

::slotted(*) {
  display: contents !important;
}

:host([theme='default']) {
  @include ads-vars-component-expansion-panel-default;
}

:host([theme='dark']) {
  @include ads-vars-component-expansion-panel-dark;
}

:host([dir='ltr']) {
  @include ads-vars-component-expansion-panel-ltr;
}

:host([dir='rtl']) {
  @include ads-vars-component-expansion-panel-rtl;
}

.c-expansion-panel {
  @include ads-expansion-panel;
}
